import { createValidate } from 'typia'
import { validateGuard } from 'components/shared/parsing/parsing.js'

export type IQuotationCostRuleDTO = {
  name: string
}

export class QuotationCostRuleDTO {
  name: string

  constructor(data: IQuotationCostRuleDTO) {
    this.name = data.name
  }
}

const validate = createValidate<IQuotationCostRuleDTO | null>()

export const parseQuotationCostRuleDTO = (data: unknown): QuotationCostRuleDTO | null => {
  validateGuard(validate, data, 'quotation cost rule')
  if (data === null) return null
  return new QuotationCostRuleDTO(data)
}
